import bearer from "@websanova/vue-auth/drivers/auth/bearer";
import axios from "@websanova/vue-auth/drivers/http/axios.1.x";
import router from "@websanova/vue-auth/drivers/router/vue-router.2.x";
import rawAxios from 'axios'; // ✅ This gives you the real Axios


// Auth base configuration some of this options
// can be override in method calls
// axios.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("smwtkn");
//     if (token && isTokenExpired(token)) {
//       console.warn("Token expired. Logging out...");
//       localStorage.removeItem("smwtkn");
//       router.push('/sign-in'); // Use Vue Router
//       return Promise.reject(new Error("Token expired"));
//     }
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`; // Add Bearer token
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// function isTokenExpired(token) {
//   // Input validation
//   if (!token || typeof token !== 'string' || token.split('.').length !== 3) {
//     console.warn('Invalid token format:', token);
//     return true; // Treat invalid tokens as expired
//   }

//   try {
//     // Decode the payload
//     const payload = JSON.parse(atob(token.split('.')[1]));
    
//     // Check if exp field exists
//     if (!payload.exp || typeof payload.exp !== 'number') {
//       console.warn('Token payload missing or invalid exp field:', payload);
//       return true; // Treat tokens without valid exp as expired
//     }

//     // Convert expiry to milliseconds and add a buffer (e.g., 30 seconds)
//     const buffer = 30 * 1000; // 30 seconds buffer
//     const expiry = payload.exp * 1000; // Convert seconds to milliseconds
    
//     // Check if token is expired, considering buffer
//     return Date.now() > (expiry - buffer);
//   } catch (error) {
//     console.error('Error decoding or parsing token:', error);
//     return true; // Treat tokens with errors as expired
//   }
// }
rawAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("smwtkn");

    if (token) {
      if (isTokenExpired(token)) {
        console.warn("Token expired. Logging out...");
        localStorage.removeItem("smwtkn");
        router.push("/sign-in");
        return Promise.reject(new Error("Token expired"));
      }
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

function parseJwtPayload(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("Token decode failed:", e);
    return null;
  }
}
function isTokenExpired(token) {
  const payload = parseJwtPayload(token);
  if (!payload || !payload.exp) return true;

  const buffer = 30 * 1000;
  return Date.now() > (payload.exp * 1000 - buffer);
}




const config = {
  auth: bearer,
  http: axios,
  router: router,
  //tokenDefaultKey: "sevenupjwt",
  tokenDefaultKey: "smwtkn",
  tokenStore: ["localStorage"],
  rolesKey: "role",
  registerData: { url: "/api/Employee/EmployeeSignUp", method: "POST", redirect: "" },
  loginData: {
    url: "/api/Auth/Authenticate",
    method: "POST",
    redirect: "",
    fetchUser: true,
  },
  logoutData: {
    url: "",
    method: "Get",
    redirect: "/sign-in",
    makeRequest: false,
  },
  fetchData: { url: "/api/User/Get", method: "GET", enabled: true ,error: (err) => {
    console.error("Fetching user data failed:", err);

    if (err.response && err.response.status === 401) {
      console.warn("Unauthorized request. Logging out...");
      
      // Remove token from local storage
      localStorage.removeItem("smwtkn");
      
      // Redirect to home page
      window.location.href = "/";
    }
  }}, //it is called after refreshData when we refresh our page
  refreshData: {
    url: "auth/refresh",
    method: "GET",
    enabled: false,
    interval: 30,
  },
};
export default config;
